import { Slide } from "@jelly/lesson";

import wind from "./components/wind";
import tires from "./components/tires";

const principle: Slide = {
  title: "Road & Wind Noise",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [{ name: "Tire / Road noise" }, { name: "Wind" }],
          options: {},
        },
      ],
      components: [tires, wind],
      extraContent: [[]],
    },
  },
};

export default principle;
